/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function ReaderWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18217/reader";
        this.context=param.context;
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback);
        this.websocket.connect(param);
    }

    ReaderWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    ReaderWebsocket.prototype.openReader=function(param){
        var name="openReader";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","url","pos","page","disablePrint","disableSign","hideToolBar",
            "titleBarVisible","titleMaxMinVisible","leftDockVisible","leftNavigateVisible",
            "moveable","resizeable","hideLoading","filePattern"]);

        this.websocket.sendMessage({
            fun: 'OpenReader',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.readerId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.closeReader=function(param){
        var name="closeReader";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId"]);

        this.websocket.sendMessage({
            fun: 'CloseReader',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.scroll=function(param){
        var name="scroll";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","pos"]);

        this.websocket.sendMessage({
            fun: 'Scroll',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.openFile=function(param){
        var name="openFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","file","url","filePattern"]);

        this.websocket.sendMessage({
            fun: 'OpenFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.closeFile=function(param){
        var name="closeFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId"]);

        this.websocket.sendMessage({
            fun: 'CloseFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.moveWindow=function(param){
        var name="moveWindow";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","pos"]);

        this.websocket.sendMessage({
            fun: 'MoveWindow',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setSignButtons=function(param){
        var name="setSignButtons";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","visible","enable"]);

        this.websocket.sendMessage({
            fun: 'SetSignButtons',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setToolBar=function(param){
        var name="setToolBar";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","visible","enable"]);

        this.websocket.sendMessage({
            fun: 'SetToolBar',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setRatio=function(param){
        var name="setRatio";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","ratio"]);

        this.websocket.sendMessage({
            fun: 'SetRatio',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.getCurrentFileInfo=function(param){
        var name="getCurrentFileInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId"]);

        this.websocket.sendMessage({
            fun: 'GetCurrentFileInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.fileInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.gotoPage=function(param){
        var name="gotoPage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","page"]);

        this.websocket.sendMessage({
            fun: 'GotoPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.getPage=function(param){
        var name="getPage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId"]);

        this.websocket.sendMessage({
            fun: 'GetPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.page);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setTitleBar=function(param){
        var name="setTitleBar";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","visible","maxMinVisible"]);

        this.websocket.sendMessage({
            fun: 'SetTitleBar',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setLeftBar=function(param){
        var name="setLeftBar";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","navigateVisible","dockVisible"]);

        this.websocket.sendMessage({
            fun: 'SetLeftBar',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.setMainWindow=function(param){
        var name="setMainWindow";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","resizeable","moveable"]);

        this.websocket.sendMessage({
            fun: 'SetMainWindow',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ReaderWebsocket.prototype.triggerAction=function(param){
        var name="triggerAction";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["readerId","action"]);

        this.websocket.sendMessage({
            fun: 'TriggerAction',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    $m.ReaderWebsocket=ReaderWebsocket;

})(HebcaMiddleware);
